<template>
  <base-section background-style="dark">
    <motion.div
        class="services-header"
        :initial="{ opacity: 0, y: 30 }"
        :whileInView="{ opacity: 1, y: 0 }"
        :transition="{ duration: 0.6 }"
        :inViewOptions="{ once: true }"
    >
      <gradient-title text="Wie kann ich dir helfen?" tag="h2" />
      <p class="services-subtitle">Professionelle Unterstützung für deine Entwicklungsprojekte</p>
    </motion.div>

    <div class="services-grid">
      <feature-card
          v-for="(service, index) in services"
          :key="service.title"
          :title="service.title"
          :description="service.description"
          :icon="service.icon"
          :index="index"
      />
    </div>

    <call-to-action-section />
  </base-section>
</template>

<script lang="ts" setup>
import { motion } from "motion-v"
import BaseSection from "@/views/sections/BaseSection.vue"
import GradientTitle from "@/components/GradientTitle.vue"
import FeatureCard from "@/components/FeatureCard.vue"
import CallToActionSection from "@/components/CallToActionSection.vue"

const services = [
  {
    title: 'Neue Features für deine App',
    description: 'Ich erweitere deine bestehende Laravel/Vue Applikation um neue Features – sauber integriert, getestet und ohne Tech-Debt aufzubauen.',
    icon: 'laravel-original.svg'
  },
  {
    title: 'GitLab Pipeline Optimierung',
    description: 'Ich räume eure CI/CD-Prozesse auf. Schnellere Builds, automatisierte Tests und stressfreie Deployments über GitLab CI.',
    icon: 'gitlab-plain.svg'
  },
  {
    title: 'Dockerisierung',
    description: 'Vom lokalen Setup bis zur Produktion: Ich dockerisiere eure Anwendungen, damit das \'Works on my machine\'-Problem endgültig verschwindet.',
    icon: 'docker-plain.svg'
  }
]
</script>

<style scoped>
.services-header {
  text-align: center;
  margin-bottom: 4rem;
}

.services-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  max-width: 600px;
  margin: 0 auto;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 5rem;
}

@media (max-width: 768px) {
  .services-subtitle {
    font-size: 1rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
</style>
